<template>
    <div id="map-container"></div>
</template>

<script>
export default {
    name: "baiduMap",
    props: {
        address: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            map: null,
            marker: null,
            center: { lat: '', lng: '' }
        };
    },
    mounted() {
        // 动态加载百度地图API
        this.loadBaiduMapScript();
    },
    beforeDestroy() {
        if (this.map) {
            // 1. 清除所有覆盖物
            this.map.clearOverlays(); 
            
            // 2. 禁用地图交互
            this.map.disableScrollWheelZoom();
            
            // 3. 移除事件监听（以点击事件为例）
            this.map.removeEventListener("click", this.clickHandler);
            
            // 4. 释放地图实例
            this.map = null;
            
            // 5. 可选：移除地图容器（根据需求）
            const container = document.getElementById('map-container');
            if (container) container.innerHTML = '';
        }
    },
    methods: {
        loadBaiduMapScript() {
            if (typeof BMap !== 'undefined') {
                this.initMap();
                return;
            }

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://api.map.baidu.com/api?v=3.0&ak=kysDNgzlChrxkjyXC6Kb8wjvCKDI0Av3&callback=baiduMapInit`;
            script.onerror = (error) => {
                console.error('百度地图脚本加载失败:', error);
                this.$Message.error("地图服务加载失败，请检查网络连接");
            };
            
            // 全局回调函数
            window.baiduMapInit = () => {
                this.initMap();
            };
            
            document.head.appendChild(script);
        },

        initMap() {
            // 确保核心对象存在
            if (!window.BMap || !BMap.Geocoder) {
                console.error('BMap 核心库未正确加载');
                return;
            }

            const geocoder = new BMap.Geocoder();
            // 将第四个参数设为空字符串（或省略），扩大搜索范围
            geocoder.getPoint(
                this.address,
                (point) => {
                    if (point) {
                        this.center.lat = point.lat;
                        this.center.lng = point.lng;
                        this.createMap();
                    } else {
                        this.$Message.error("地址解析失败，请检查地址格式或尝试输入英文地址");
                    }
                },
                '', // 关键：此处原为'全国'，改为空字符串或省略以允许全球搜索
            );
        },

        createMap() {
            this.map = new BMap.Map("map-container");
            this.map.centerAndZoom(new BMap.Point(this.center.lng, this.center.lat), 13);
            this.map.enableScrollWheelZoom(true);
            
            // 添加初始标记
            this.addMarker(this.center);

            // 点击事件
            this.map.addEventListener("click", (evt) => {
                this.addMarker({ lat: evt.point.lat, lng: evt.point.lng });
            });
        },

        addMarker(position) {
            const point = new BMap.Point(position.lng, position.lat);
            this.$emit('child-to-parent', { lat: position.lat, lng: position.lng });

            if (this.marker) {
                this.map.removeOverlay(this.marker);
            }

            this.marker = new BMap.Marker(point);
            this.map.addOverlay(this.marker);
        }
    },
};
</script>

<style scoped>
#map-container {
    width: 100%;
    height: 600px; /* 必须设置高度 */
}
</style>